export type References = {
  sectors: {
    artists: { co2: { score: number } };
    team: { co2: { score: number } };
    public: { co2: { score: number } };
    site: { co2: { score: number } };
  };
};

export const EMPTY_REFERENCES: References = {
  sectors: {
    artists: {
      co2: { score: NaN },
    },
    team: {
      co2: { score: NaN },
    },
    public: {
      co2: { score: NaN },
    },
    site: {
      co2: { score: NaN },
    },
  },
};
